const getters = {
  list: state => state.list,
  isLoading: state => state.isLoading,
  isUploading: state => state.isUploading,
  filter: state => state.filter,
  hasEmpty: state => state.hasEmpty,
  listFF: state => state.activeListFF,
  containersList: state => state.activeListContainer,
  chaList: state => state.activeListCha,
  portList: state => state.activeListPort,
  header: state => state.header,
  all: state => state.all,
  isShowLoading: state => state.isShowLoading,
  excludeList: state => state.excludeList,
  getSlab: state => state.slabData,
};
export default getters;
